
  import { Component, Vue } from 'vue-property-decorator';

  @Component
  export default class ConfirmRegister extends Vue {
    data() {
      return {
        studio: ''
      }
    };

    created() {
      this.$data.studio = this.$data.RCEnvironment.VUE_APP_PARTNER_NAME;
    }
  }
